import { createSelector } from 'reselect'

import { actionTypes } from 'actions/actionTypes'
import { getDisabledSlotDates, userHasAvailableSlots } from 'routes/Menu/selectors/boxSummary'
import { getPromoCode } from 'selectors/basket'
import { getLandingDay } from 'utils/deliveries'
import { addDisabledSlotIds } from 'utils/deliverySlotHelper'

export const getPromoStore = ({ promoStore }) => promoStore

export const getCurrentPromoCodeData = createSelector(
  [getPromoCode, getPromoStore],
  (promoCode, promoStore) => {
    if (!promoCode) {
      return null
    }

    return promoStore.getIn([promoCode, 'codeData'], null)
  },
)
export const getCurrentPromoCodeCustomText2 = createSelector(
  [getCurrentPromoCodeData],
  (promoCodeData) => {
    if (!promoCodeData) {
      return null
    }

    return promoCodeData.getIn(['campaign', 'landingDetails2'], null)
  },
)

export const getPendingSlice = (state) => state.pending

export const createSelectIsPendingByActionType = (actionType) =>
  createSelector(getPendingSlice, (pendingSlice) => pendingSlice.get(actionType))

export const getNumberOfPeople = (state) => state.signup.getIn(['numberOfPeople'])

export const getTempDeliveryOptions = (state) => {
  const deliveryDaysWithDisabled = addDisabledSlotIds(state.boxSummaryDeliveryDays)

  const landing = getLandingDay(state, {
    useCurrentSlot: true,
    cantLandOnOrderDate: true,
    useBasketDate: false,
  })

  const tempDate = state.temp.get('date', landing.date)
  const tempSlotId = state.temp.get('slotId', landing.slotId)
  const disabledSlots = getDisabledSlotDates(state)

  return { deliveryDaysWithDisabled, tempDate, tempSlotId, disabledSlots }
}

export const getDistrict = (state) => state.signup.getIn(['wizard', 'district'])
export const getAmountOfCustomers = (state) => state.signup.getIn(['wizard', 'amountOfCustomers'])
export const getUserHasAvailableSlots = (state) => userHasAvailableSlots(state)
export const getTempPostcode = (state) => state.temp.get('postcode', '')

export const getDeliveryDaysError = (state) =>
  state.error.get(actionTypes.BOXSUMMARY_DELIVERY_DAYS_RECEIVE, false)

export const getPostcodePending = (state) => state.basket.get('postcodePending')
